export function validateRegionData(data = {}) {
  let myErrors = {};

  if (!data.region) {
    myErrors.region = 'Region Name is required!';
  }
  if (!data.subRegions || !data.subRegions?.length) {
    myErrors.subRegions = 'Please select sub regions!';
  }

  return {
    isValid: Object.values(myErrors).length === 0,
    myErrors
  }
}